/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import * as R from 'ramda';
import { useQuery } from '@apollo/client';
import GetSimulationCompanySearchCompanyQuery from '../graphql/queries/GetSimulationCompanySearchCompanyQuery.js';

const useGetSimulationCompanySearchCompanyQuery = (args) => {
  const { data, error, loading, refetch } = useQuery(GetSimulationCompanySearchCompanyQuery, args);

  return {
    error,
    loading,
    refetch,
    getSimulationCompanySearchCompany: R.omit(['__typename'], data?.getSimulationCompanySearchCompany_simulation_company || {})
  };
};

export default useGetSimulationCompanySearchCompanyQuery;
